import React from 'react';
import { useTranslate } from 'react-admin';
import { Form } from 'antd';
import { RoyaltyInput } from './MonthlyRoyaltyInput';

const MktRoyaltyInput = ({ defaultRoyalty, disabled }) => {
  const t = useTranslate();

  return (
    <Form.Item
      name="mktRoyalty"
      rules={[
        ({ getFieldValue }) => ({
          validator() {
            const value = getFieldValue('mktRoyalty');

            if (value < 0 || value === 0) {
              return Promise.reject(
                new Error(
                  t('ra.validation.greater', {
                    min: 0,
                  }),
                ),
              );
            }

            if (value > 100) {
              return Promise.reject(
                new Error(
                  t('ra.validation.maxValue', {
                    max: 100,
                  }),
                ),
              );
            }

            return Promise.resolve();
          },
        }),
      ]}
      disabled={disabled}
    >
      <RoyaltyInput defaultRoyalty={defaultRoyalty} placeholder={t('resources.brand.mktRoyaltyPlaceholder')} />
    </Form.Item>
  );
};

export default MktRoyaltyInput;
